import React, { useEffect, useState } from "react";
import {
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  Area,
} from "recharts";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import DropDownCustom from "../DropDownCustom/DropDownCustom";
import { getSaleGrowth } from "../../Actions/actions";

const numberFormatter = (value) => {
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`;
  } else if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}k`;
  }
  return value;
};

function DashboardGraph({ data }) {
  const { loginData, saleGrowth, singleClient } = useSelector(
    (state) => state.userReducer
  );
  const dispatch = useDispatch();
  const [selectedStatus, setSelectedStatus] = useState("7days");
  const statusOptions = [
    { value: "7days", label: "Last 7 Days" },
    { value: "30days", label: "Last 30 Days" },
    { value: "year", label: "Last 12 Months" },
  ];
  useEffect(() => {
    dispatch(
      getSaleGrowth(
        loginData?.accessToken,
        selectedStatus,
        singleClient?.id,
        () => {}
      )
    );
  }, [selectedStatus, singleClient]);
  const handleChanges = (selectedOption, setterFunction) => {
    setterFunction(selectedOption.value);
  };

  const selectedStatusOption = statusOptions?.find(
    (option) => option.value === selectedStatus
  );
  return (
    <div className="bg-white rounded-2xl shadow-lg py-6">
      <div className="flex justify-between items-center mb-4 px-6">
        <h2 className="text-xl font-bold text-gray-900">Sales Growth</h2>
        {/* <DropDownComponent
          label={selectedStatus.label}
          value={selectedStatus.value}
          onChange={setSelectedStatus}
          data={[
            { value: "last30days", label: "Last 30 Days" },
            { value: "weekly", label: "Weekly" },
          ]}
        /> */}
        <div className="w-[20%] justify-end">
          <DropDownCustom
            // isAligned={true}
            isClient={true}
            selectedValue={selectedStatusOption}
            handleChanges={(option) => handleChanges(option, setSelectedStatus)}
            options={statusOptions}
            isSearchable={false}
            label="Status"
            placeholder="Select Status"
          />
        </div>
      </div>

      {/* <div className="flex justify-end gap-4 mb-4 px-6">
        <div className="flex flex-row items-center gap-1">
          <div className="w-3 h-3 bg-slate-600 rounded-full" />
          <h2 className="text-xs font-normal text-gray-900">Task Managment</h2>
        </div>
        <div className="flex flex-row items-center gap-1">
          <div className="w-3 h-3 bg-yellow-400 rounded-full" />
          <h2 className="text-xs font-normal text-gray-900">Reporting</h2>
        </div>
      </div> */}

      <ResponsiveContainer width="100%" style={{ marginTop: 50 }} height={300}>
        <ComposedChart data={saleGrowth}>
          <XAxis
            dataKey="label"
            tick={{ fill: "#A0AEC0", fontSize: 12 }}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            tickFormatter={numberFormatter}
            tick={{ fill: "#A0AEC0", fontSize: 12 }}
            tickLine={false}
            axisLine={false}
          />

          <Tooltip content={<CustomTooltip />} />

          <Area
            type="basis"
            dataKey="growthRate"
            stroke="#2D1B3F"
            fill="#2D1B3F"
            strokeWidth={2}
            fillOpacity={0.1}
          />
          <Area
            type="basis"
            dataKey="revenue"
            stroke="#E4665C"
            fill="#E4665C"
            strokeWidth={2}
            fillOpacity={0.1}
          />
          <Bar
            dataKey="revenue"
            fill="#2D1B3F"
            barSize={6}
            radius={[10, 10, 0, 0]}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white p-2 border rounded shadow">
        {console.log(payload)}
        <p className="text-sm text-gray-700 font-semibold">{label}</p>
        <p className="text-sm text-gray-500">
          Growth Rate: {numberFormatter(payload[0].value)} AED
        </p>
        <p className="text-sm text-gray-500">
          Revenue: {numberFormatter(payload[1].value)} AED
        </p>
      </div>
    );
  }

  return null;
};
export default DashboardGraph;
